// extracted by mini-css-extract-plugin
export default {"heading":"PrivacyPolicyPage_heading__HNcyO","content":"PrivacyPolicyPage_content__GaLrv"};